import React, { useState, useEffect } from "react";
import { loadStripe } from '@stripe/stripe-js';
import { useRouter } from 'next/router';
import { getSessionStatusApi } from '@/services/userApi';

// Make sure to call `loadStripe` outside of a component's render to avoid
// recreating the `Stripe` object on every render.
// This test secret API key is a placeholder. Don't include personal details in requests with this key.
// To see your test secret API key embedded in code samples, sign in to your Stripe account.
// You can also find your test secret API key at https://dashboard.stripe.com/test/apikeys.
const stripePromise = loadStripe(process.env.NEXT_PUBLIC_STRIPE_PUBLISHABLE_KEY);

const Return = () => {
  const [status, setStatus] = useState(null);
  const [customerEmail, setCustomerEmail] = useState('');
  const router = useRouter();

  useEffect(() => {
    if (!router.isReady) return;

    const { session_id } = router.query;

    if (session_id) {
      getSessionStatusApi(session_id)
        .then((data) => {
          setStatus(data.status);
          setCustomerEmail(data.customer_email);
        })
        .catch((error) => {
          console.error('Error fetching session status:', error);
          // Handle error (e.g., show error message to user)
        });
    }
  }, [router.isReady, router.query]);

  if (status === 'open') {
    router.push('/plans-billing/checkout');
    return null;
  }

  if (status === 'complete') {
    return (
      <section id="success">
        <p>
          Thank you for subscribing to Juree AI Pro! A confirmation email will be sent to {customerEmail}.

          If you have any questions, please email <a href="mailto:orders@example.com">help@juree.ai</a>.
        </p>
      </section>
    )
  }

  return null;
}

export default Return;